import {config as numberColumnConfig} from '../../common/NumberColumn';

export const prop = 'cTTotal';

export const config = (labels) =>
	numberColumnConfig({
		id: 'gaTotalTasks',
		label: labels.totalTasksCapitalized,
		prop,
		width: 'minmax(var(--px-150), 1fr)'
	});
